import React, { Component } from 'react';
import { Button } from 'antd';
import styles from '../ModelList.module.css';

class ModelActiveComponent extends Component {
  render() {
    const { modelActiveRecord, history, archive, startInference } = this.props;
    const modifiedFDate =
      modelActiveRecord.updatedOn && new Date(modelActiveRecord.updatedOn);
    const createDate =
      modelActiveRecord.createdOn && new Date(modelActiveRecord.createdOn);
    const exportDate =
      modelActiveRecord.exportedOn && new Date(modelActiveRecord.exportedOn);
    const activeItemRows = [
      {
        label: 'Created On',
        value: (
          <span>
            {createDate && createDate.getDate()
              ? `${createDate.getDate()}-${
                  createDate.getMonth() + 1
                }-${createDate.getFullYear()}`
              : '--'}
          </span>
        ),
      },
      {
        label: 'Updated On',
        value: (
          <span>
            {modifiedFDate && modifiedFDate.getDate()
              ? `${modifiedFDate.getDate()}-${
                  modifiedFDate.getMonth() + 1
                }-${modifiedFDate.getFullYear()}`
              : '--'}
          </span>
        ),
      },
      {
        label: 'Exported On',
        value: (
          <span>
            {exportDate && exportDate.getDate()
              ? `${exportDate.getDate()}-${
                  exportDate.getMonth() + 1
                }-${exportDate.getFullYear()}`
              : '--'}
          </span>
        ),
      },
      {
        label: 'Avg. Time',
        value:
          modelActiveRecord && modelActiveRecord.averageTime
            ? `${modelActiveRecord.averageTime} secs`
            : '--',
      },
      {
        label: 'Precision',
        value:
          modelActiveRecord && modelActiveRecord.precision
            ? modelActiveRecord.precision
            : '--',
      },
      {
        label: 'Accuracy',
        value:
          modelActiveRecord && modelActiveRecord.accuracy
            ? `${modelActiveRecord.accuracy}%`
            : '--',
      },
      {
        label: 'Recall',
        value:
          modelActiveRecord && modelActiveRecord.recall
            ? modelActiveRecord.recall
            : '--',
      },
    ];

    return (
      <div
        className={styles.activeContentWrapper}
        style={
          modelActiveRecord && modelActiveRecord.modelId
            ? {
                alignItems: 'flex-start',
              }
            : {
                alignItems: 'center',
                height: '100%',
              }
        }
      >
        {modelActiveRecord && modelActiveRecord.modelId ? (
          <>
            <div className={styles.activeTitleContainer}>
              <span className={styles.activeItemLabel}>Model Id</span>
              <span className={styles.activeItemTitle}>
                {modelActiveRecord && modelActiveRecord.modelId
                  ? modelActiveRecord.modelId
                  : '--'}
              </span>
            </div>
            <div className={styles.activeDescriptionContainer}>
              <span className={styles.activeItemLabel}>Description</span>
              <span className={styles.activeItemValue}>Model Log : </span>
              <span className={styles.activeItemValue}>
                {modelActiveRecord && modelActiveRecord.modelDescription
                  ? modelActiveRecord.modelDescription
                  : '--'}
              </span>
            </div>
            {activeItemRows.map((item, index) => (
              <div
                className={styles.activeItemContainer}
                key={`${index}-active-item-container`}
              >
                <div className={styles.activeItem}>
                  {item.label && (
                    <span className={styles.activeItemLabel}>{item.label}</span>
                  )}
                  {item.value && (
                    <span className={styles.activeItemTitle}>{item.value}</span>
                  )}
                </div>
              </div>
            ))}
            <div className={styles.activeFooterContainer}>
              {/* {modelActiveRecord && !modelActiveRecord.modelIsActive && <span className={styles.modelInactiveInfo}>
								<span className="flaticon-info"></span>
								This model has been deleted from the workspace.
							</span>
						} */}
              <Button
                className={`${styles.actionFooterButton} ${
                  !archive &&
                  modelActiveRecord &&
                  modelActiveRecord.hasOnlineInference &&
                  styles.buttonDisabled
                }`}
                onClick={() => {
                  archive
                    ? this.props.unArchive(modelActiveRecord.modelId)
                    : this.props.startInference();
                }}
              >
                {archive ? 'Unarchive' : 'Start Inference'}
              </Button>
              <Button
                style={{
                  marginLeft: 10,
                }}
                className={styles.actionFooterButton}
                onClick={() => this.props.inferenceList()}
              >
                View Runtime History
              </Button>
            </div>
          </>
        ) : (
          <div className={styles.noImagePreview}>
            <span className={styles.noPreviewText}>There is no data</span>
          </div>
        )}
      </div>
    );
  }
}

export default ModelActiveComponent;
